module.exports = __webpack_public_path__ + "img/branch-guangzhou.8348c87a.jpeg";